// extracted by mini-css-extract-plugin
export var stepActive = "_2s-3";
export var stepCompleted = "_2s-4";
export var stepConnectorLine = "_2s-b";
export var stepIndicatorCircle = "_2s-6";
export var stepIndicatorCircleCompleted = "_2s-7";
export var stepIndicatorCircleDefault = "_2s-8";
export var stepIndicatorTextCompleted = "_2s-9";
export var stepIndicatorTextDefault = "_2s-a";
export var stepPending = "_2s-5";
export var wizardContainer = "_2s-1";
export var wizardContent = "_2s-2";
export var wizardModal = "_2s-0";